exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Header-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 1vh; }\n\n.Header-subcontainer {\n  margin-top: 20px;\n  display: flex;\n  width: 90%;\n  justify-content: space-between;\n  align-items: center;\n  z-index: 1; }\n\n.Header-buttons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; }\n\n.Header-back-button {\n  font-size: 30px;\n  margin-right: 20px; }\n\n.Header-back-button path {\n  fill: transparent;\n  stroke-width: 20px; }\n\n.Header-fa-hamburger {\n  color: white;\n  font-size: 30px; }\n\n.Header-logo img {\n  width: 100px; }\n\n.Header-hamburger {\n  display: none; }\n\n@media screen and (orientation: portrait) and (max-width: 768px), (orientation: landscape) and (max-width: 812px) {\n  .Header-container {\n    margin-top: 5px; }\n  .Header-logo img {\n    width: 80px; }\n  .Header-social {\n    display: none; }\n  .Header-hamburger {\n    display: flex;\n    justify-content: flex-end; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Marginals/Header.scss
// module id = 112
// module chunks = 0